import type { PromotionLink, TeamMember } from '@/domain/affiliate/Affiliate'
import type { AffiliateRepository } from '@/domain/affiliate/AffiliateRepository'
import type { AgentId } from '@/domain/shared/Brand'
import { API_PATHS } from '@/infrastructure/http/ApiPaths'
import type { HttpClient } from '@/infrastructure/interfaces/HttpClient'
import {
  toPromotionLink,
  toTeamMembers,
} from '@/infrastructure/mapper/ApiToDomainMapper'
import { compilePath } from '@/shared/PathUtils'

export class HttpAffiliateRepository implements AffiliateRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async getPromotionLink(agentId: AgentId): Promise<PromotionLink> {
    const response = await this.httpClient.request({
      path: compilePath(API_PATHS.AFFILIATE.PROMO_LINK, { agentId }),
      method: 'GET',
    })
    return toPromotionLink(response)
  }

  async getRecentlyJoinedMembers(agentId: AgentId): Promise<TeamMember[]> {
    const response = await this.httpClient.request({
      path: compilePath(API_PATHS.AFFILIATE.RECENT_CONSUMERS, { agentId }),
      method: 'GET',
    })
    return toTeamMembers(response)
  }
}
